import type {
	EntityViolationsOut,
	PolicyOut,
	PolicyViolationOut,
} from '@repo/api-codegen';
import { makeAutoObservable } from 'mobx';
import {
	fetchSecodaEntity,
	updateSecodaEntity,
} from '../../../../api/hooks/secodaEntity/fetchSecodaEntities';
import type { DjangoValueType } from '../../../TemplatePage/types';

export class PolicyIssueStore {
	// @ts-expect-error TS(2564): Property 'entity' has no initializer and is not de... Remove this comment to see the full error message
	entity: ISecodaEntity;
	selectedEntityId: string | null = null;
	isOpen = false;
	loading = false;
	isError = false;
	title = '';
	description = '';
	icon = '🗂';
	policy: PolicyOut | null = null;
	violations: PolicyViolationOut[] | null = null;
	onClose?: () => void;
	columnViolations: EntityViolationsOut[] | null = null;
	externalUrl?: string | null;

	constructor() {
		makeAutoObservable(this);
	}

	setSelectedEntityId = (value: string | null) => {
		this.selectedEntityId = value;
	};

	setColumnViolations = (
		columnViolations: EntityViolationsOut[] | null,
		externalUrl?: string | null
	) => {
		this.columnViolations = columnViolations;
		this.externalUrl = externalUrl;
	};

	setLoading() {
		this.loading = true;
	}

	resetLoading() {
		this.loading = false;
	}

	setIsError = (value: boolean) => {
		this.isError = value;
	};

	openPolicyIssueSidebarWithId = async (
		policy: PolicyOut,
		violations: PolicyViolationOut[],
		entityId: string,
		params: unknown = undefined,
		onClose: (() => void) | undefined = undefined
	) => {
		this.setLoading();
		this.setIsOpen(true);
		this.policy = policy;
		this.violations = violations;

		this.onClose = onClose;
		await fetchSecodaEntity(entityId, params)
			.then((entity) => {
				this.entity = entity;

				this.title = entity.title || 'Untitled';
				this.description = entity.description || '';
				if (entity.icon) {
					this.icon = entity.icon;
				}

				this.resetLoading();
			})
			.catch(() => {
				this.resetLoading();
				this.setIsError(true);
			});
	};

	openEntityDrawerWithError = () => {
		this.setIsError(true);
		this.setIsOpen(true);
	};

	updateEntity = async (
		key: string,
		value: DjangoValueType,
		saveRemotely = true
	) => {
		this.entity[key] = value;
		if (saveRemotely) {
			await updateSecodaEntity({
				data: {
					id: this.entity.id,
					[key]: value,
				},
			});
		}
	};

	updateByKey =
		(key: string) =>
		async (value: DjangoValueType, saveRemotely = true) => {
			await this.updateEntity(key, value, saveRemotely);
		};

	setTitle = (value: string) => {
		this.title = value;
	};

	setDescription = (value: string) => {
		this.description = value;
	};

	setIcon = (value: string) => {
		this.icon = value;
	};

	setIsOpen = (value: boolean) => {
		this.isOpen = value;
	};

	closeEntityDrawer = () => {
		this.setIsOpen(false);
		this.setIsError(false);
		this.resetLoading();

		this.onClose?.();
		this.onClose = undefined;
	};
}

export default new PolicyIssueStore();
